import { PROPERTY_LEVELS } from '@/constants/property-level';
import type { Projects } from '@/features/projects/api/projects';
import { getFinalAreaRoom } from '@/utils/getFinalAreaRoom';
import { getFinalLivingArea } from '@/utils/getFinalLivingArea';
import { getFinalPrice } from '@/utils/getFinalPrice';

import type { Estates } from '../api/estates';
import { EstatesGridCard } from './estate-grid-card';
import type { EstateInfoProps } from './estate-info';
import { EstatesInfiniteScroll } from './estates-infinite-scroll';

type EstateGridData = Pick<Estates[number], 'id' | 'name' | 'status' | 'thumbnail'> &
  Partial<Pick<Estates[number], 'creator' | 'estateDetails' | 'estateAreasRooms'>> & {
    address?: {
      address?: string | null;
      postalCode?: string | null;
      city?: string | null;
    } | null;
    prices?: Projects[number]['prices'] | Estates[number]['prices'] | null;
    areaRooms?: Projects[number]['areaRooms'] | null;
  };

type EstateGridProps = {
  filters?: object;
  data: EstateGridData[];
  filterOwn?: boolean;
  infiniteScroll?: boolean;
  type?: 'estate' | 'project';
  btnActionRender?: (props: EstateInfoProps) => JSX.Element;
};

export const EstateGrid: React.FC<EstateGridProps> = ({
  data,
  filters,
  filterOwn,
  infiniteScroll = true,
  type = 'estate',
  btnActionRender,
}) => {
  return (
    <div className="mb-[30px] grid grid-cols-1 gap-[27px] lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {data.map((estate) => {
        const price = getFinalPrice(estate);
        const roomsCount = getFinalAreaRoom(estate);
        const livingArea = getFinalLivingArea(estate);
        return (
          <EstatesGridCard
            key={estate.id}
            propertyLevel={
              'estateDetails' in estate ? PROPERTY_LEVELS.OBJECT : PROPERTY_LEVELS.PROJECT
            }
            creator={`${estate.creator?.firstName ?? ''} ${estate.creator?.lastName ?? ''}`}
            address={estate.address}
            status={estate.status}
            id={estate.id}
            thumbnailId={estate.thumbnail?.mediaId}
            livingArea={livingArea}
            roomsCount={roomsCount}
            name={estate.name}
            price={price}
            btnActionRender={btnActionRender}
          />
        );
      })}
      {infiniteScroll ? (
        <EstatesInfiniteScroll
          Card={EstatesGridCard}
          filters={filters}
          filterOwn={filterOwn}
          type={type}
        />
      ) : null}
    </div>
  );
};
